// University of the Pacific's bachelor's majors (#2839). Read on 2026-10-01
// from Pacific's official Academic Catalog 2026-2027 (catalog.pacific.edu,
// "2026-2027 | Academic Catalog"): each school's page lists its bachelor's
// programs, and the College of the Pacific's department pages give each
// department's "Majors Offered". Each major is listed once with its
// degree(s) (BA, BS, BFA, BM; "BA or BS" where a department offers both).
// Left out: departmental honors, teaching-credential, "and Law", blended
// bachelor's/master's and pathway versions of a major, the Jazz Studies
// honors track, concentrations, minors, certificates, Pre-Pharmacy (a
// pre-professional track) and graduate degrees. Data Science, Product Design
// and Entrepreneurship and Sustainability are cross-college majors on the
// catalog's Interdisciplinary Programs page (also shown under Business or
// Engineering and Computer Science, and under College of the Pacific
// departments); they are listed once, there. Engineering Physics is listed
// once, under Engineering and Computer Science, though the Physics
// department page also describes it. The catalog spells "Conservatory Of
// Music" and "Eberhardt School Of Business"; the names here use lowercase
// "of". "&" in department names is written "and".
const majors = {
    "slug": "university-of-the-pacific",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in Pacific's official 2026-2027 Academic Catalog, grouped by the school or college that offers it, with the degree it leads to. Minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "College of the Pacific",
            "source": {
                "label": "Pacific Academic Catalog 2026-2027, College of the Pacific",
                "url": "https://catalog.pacific.edu/uop/collegeofthepacific/"
            },
            "note": "Departmental honors, teaching-credential, blended bachelor's/master's and pathway versions of a major, and concentrations, are left out; the major is listed once.",
            "majors": [
                {
                    "name": "Art",
                    "degree": "BFA"
                },
                {
                    "name": "Media Arts and Production",
                    "degree": "BA"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BA or BS"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA or BS"
                },
                {
                    "name": "Communication",
                    "degree": "BA"
                },
                {
                    "name": "Criminal Justice",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BA or BS"
                },
                {
                    "name": "English and Writing Professions",
                    "degree": "BA"
                },
                {
                    "name": "Geological and Environmental Sciences",
                    "degree": "BA or BS"
                },
                {
                    "name": "Health and Exercise Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Health and Exercise Science",
                    "degree": "BS"
                },
                {
                    "name": "Public Health and Community Wellness",
                    "degree": "BA or BS"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Social Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA or BS"
                },
                {
                    "name": "Applied Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Asian Language and Studies",
                    "degree": "BA"
                },
                {
                    "name": "French Studies",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BA or BS"
                },
                {
                    "name": "International Relations",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Self-Designed Major",
                    "degree": "BA or BS"
                }
            ]
        },
        {
            "name": "Benerd College",
            "source": {
                "label": "Pacific Academic Catalog 2026-2027, Benerd College",
                "url": "https://catalog.pacific.edu/uop/benerdcollege/"
            },
            "majors": [
                {
                    "name": "General Studies",
                    "degree": "BA"
                },
                {
                    "name": "Healthcare Administration and Leadership",
                    "degree": "BS"
                },
                {
                    "name": "Organizational Leadership",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Conservatory of Music",
            "source": {
                "label": "Pacific Academic Catalog 2026-2027, Conservatory of Music",
                "url": "https://catalog.pacific.edu/uop/conservatoryofmusic/"
            },
            "majors": [
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Jazz Studies",
                    "degree": "BM"
                },
                {
                    "name": "Music Composition",
                    "degree": "BM"
                },
                {
                    "name": "Music Education",
                    "degree": "BM"
                },
                {
                    "name": "Music History",
                    "degree": "BM"
                },
                {
                    "name": "Music Industry Studies",
                    "degree": "BS"
                },
                {
                    "name": "Music Management",
                    "degree": "BM"
                },
                {
                    "name": "Music Performance",
                    "degree": "BM"
                },
                {
                    "name": "Music Therapy",
                    "degree": "BM"
                }
            ]
        },
        {
            "name": "Eberhardt School of Business",
            "source": {
                "label": "Pacific Academic Catalog 2026-2027, Eberhardt School of Business",
                "url": "https://catalog.pacific.edu/uop/eberhardtschoolofbusiness/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BS"
                },
                {
                    "name": "Business Administration",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Engineering and Computer Science",
            "source": {
                "label": "Pacific Academic Catalog 2026-2027, School of Engineering and Computer Science",
                "url": "https://catalog.pacific.edu/uop/schoolofengineeringandcomputerscience/"
            },
            "majors": [
                {
                    "name": "Bioengineering",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Engineering Management",
                    "degree": "BS"
                },
                {
                    "name": "Engineering Physics",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Interdisciplinary Programs",
            "source": {
                "label": "Pacific Academic Catalog 2026-2027, Interdisciplinary Programs",
                "url": "https://catalog.pacific.edu/uop/interdisciplinary-majors/"
            },
            "note": "Cross-college majors, which the catalog also lists under the schools that share them.",
            "majors": [
                {
                    "name": "Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Product Design and Entrepreneurship",
                    "degree": "BS"
                },
                {
                    "name": "Sustainability",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Health Sciences",
            "source": {
                "label": "Pacific Academic Catalog 2026-2027, School of Health Sciences",
                "url": "https://catalog.pacific.edu/uop/schoolofhealthsciences/"
            },
            "majors": [
                {
                    "name": "Speech-Language Pathology",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Thomas J. Long School of Pharmacy",
            "source": {
                "label": "Pacific Academic Catalog 2026-2027, Thomas J. Long School of Pharmacy",
                "url": "https://catalog.pacific.edu/uop/thethomasjlongschoolofpharmacy/"
            },
            "majors": [
                {
                    "name": "Applied Science",
                    "degree": "BA"
                },
                {
                    "name": "Pharmaceutical Science",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Arthur A. Dugoni School of Dentistry",
            "source": {
                "label": "Pacific Academic Catalog 2026-2027, Arthur A. Dugoni School of Dentistry",
                "url": "https://catalog.pacific.edu/uop/arthuradugonischoolofdentistry/"
            },
            "majors": [
                {
                    "name": "Dental Hygiene",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
